import {Term} from '../../terms/components/TermsComponent';

export const securityOfData: Term[] = [
  {
    id: '10.1',
    term:
      'We use reasonable precautions to keep the personal information disclosed to us secure and to disclose such information only to responsible third parties after permission from the user. The security of your data is important to us but remember that no method of transmission over the Internet, or method of electronic storage, is guaranteed as secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.',
  },
];
